import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetCart as storeResetCart,
  setCart as storeSetCart,
} from '../redux/ducks/CartDucks';
import type { CartSelectionType } from '../redux/ducks/CartDucks.types';
import type { RootReducerType } from '../redux/reducers/RootReducer.types';

interface CartStore {
  currentCart: CartSelectionType | null;
  setCart: (cart: CartSelectionType) => void;
  resetCart: () => void;
}

const useCart = (): CartStore => {
  const dispatch = useDispatch();

  const currentCart = useSelector((state: RootReducerType) => state.cart.cart);

  const setCart = useCallback(
    (cart: CartSelectionType) => {
      dispatch(storeSetCart(cart));
    },
    [dispatch],
  );

  const resetCart = useCallback(() => {
    dispatch(storeResetCart());
  }, [dispatch]);

  return {
    currentCart,
    setCart,
    resetCart,
  };
};

export default useCart;
